<template>
	<div class="capture">
		<ViewMultiFormat
			:event-id="eventId"
			:event-tag-id="eventTagId"
			:is-community-cropping="false"
		/>
	</div>
</template>

<script>
import ViewMultiFormat from '@shared/Views/ViewMultiFormat.vue';

export default {
	name:       'Capture',
	components: {
		ViewMultiFormat,
	},
	data() {
		return {
			eventId:    parseInt(this.$route.params.id),
			eventTagId: this.$route.query.eventTagId,
		};
	},
};
</script>

<style lang="scss" scoped>
.capture {
	position: relative;
	min-height: 50vh;
	height: 100%;
}
</style>
